import { registerViewMount } from './navigation.js';
import { appendTrustedAdminViewFragment } from './trusted-admin-view-fragment.js';

let agentOpsMountPromise = null;

export function initAgentOpsViewFragment({ onMounted } = {}) {
  registerViewMount('admin-agent-ops', () => mountAgentOpsView(onMounted));
}

async function mountAgentOpsView(onMounted) {
  if (document.getElementById('view-admin-agent-ops')) return;
  if (agentOpsMountPromise) return agentOpsMountPromise;

  agentOpsMountPromise = (async () => {
    const host = document.getElementById('admin-lazy-view-host');
    if (!host) throw new Error('Admin lazy view host is unavailable');

    await appendTrustedAdminViewFragment(host, '/admin-views/agent-ops.html', 'Unable to load agent operations view');
    onMounted?.();
  })();

  try {
    await agentOpsMountPromise;
  } catch (error) {
    agentOpsMountPromise = null;
    throw error;
  }
}
